export default __webpack_public_path__ + "static/media/sigma_sword.aae2bafc.bmp";